import Psychologist from "./Psychologist";

export default Psychologist